export const pageVariants = {
    initial : { 
        x: 0,          
    },
    animate : {
        x: 0,
    }
}

export const pageRightVariants = {
    initial : { 
        x: "100%",          
    },
    animate : {
        x: 0,
    },
    exit : {
        opacity: 1,
        x: "100%",              
    }
}

export const pageLeftVariants = {
    initial : { 
        x: "-100%",          
    },
    animate : {
        x: 0,
    }
}

export const modalVariants = {
    initial : {
        opacity: 0, scale: 0 
    },
    animate : { 
        opacity: 1, 
        scale: 1 
    },
    exit : {
        opacity: 0,
        scale: 0,                
    }
}